<template>
    <!-- <ul class="construction_navi">
        <li><a class="back" href="/user/setting">뒤로</a></li>
    </ul> -->
    <div class="sub_Navi">
        <ul>
            <li><a class="back" href="javascript:window.history.back();">뒤로</a></li>
            <li>
                <h1>W.I.P</h1>
            </li>
            <li class="linkBox"></li>
        </ul>
    </div>
    <div class="subPage_container">
        <div class="nodata3">Work in progress.</div>
        <div class="page_loader"></div>
    </div>
</template>

<script>
export default {
    name: "Construction",
};
</script>
<style scoped>
.nodata3 {
    text-align: center;
    font-size: 16px;
    color: var(--txt-gray-color);
    width: 100%;
    padding-top: 100px;
    background: url(@/assets/images/dark/icon_rocket.png) center 20px no-repeat;
    background-size: 70px;
    margin-top: 100px;
}

@keyframes l38 {
    100% {
        background-position: 100% 0, 100% 100%, 0 100%, 0 0;
    }
}

.page_loader {
    margin: 100px auto;
    width: 35px;
    aspect-ratio: 1;
    --_g: no-repeat radial-gradient(farthest-side, #6d34f0 94%, #6d34f0);
    background: var(--_g) 0 0, var(--_g) 100% 0, var(--_g) 100% 100%, var(--_g) 0 100%;
    background-size: 40% 40%;
    /* border-radius: 50%; */
    animation: l38 .5s infinite;
}
</style>